import React, { useRef } from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { Avatar, Button, Grid, IconButton, Stack, Typography, createTheme, useMediaQuery } from '@mui/material';
import {
  AddCircleOutline,
  CloudDownload,
  CloudUpload,
  DeleteForever,
  DraftsOutlined,
  Edit,
  Person,
} from '@mui/icons-material';
import { EditLeadDetails } from '../EditLeadDetails';
import { ReadOnlyLeadDetails } from '../ReadOnlyLeadDetails';
import { datetimeFormatter } from '../../../utils/datetimeFormatter';
import DocumentStore from '../../../store/DocumentStore';
import AuthStore from '../../../store/AuthStore';
import { EditClientInfo } from '../EditClientInfo';
import { ReadOnlyClientInfo } from '../ReadOnlyClientInfo';
import { calculateCompletionPercentage } from '../../../utils/helper';
import { documentType } from '../../../utils/documentType';
import FileIcon from '../../../assets/images/FileIcon.png';
import BorderLinearProgress from '../../common/BorderLinearProgress';

const CustomPaper = styled(Paper)({
  padding: '30px',
});

const CustomUploadButton = styled(Button)({
  backgroundColor: '#F07B0E',
  color: '#fff',
  '&:hover': {
    backgroundColor: '#f1785a',
  },
  width: 'fit-content',
});

const CustomStack = styled(Stack)({
  '&:hover': {
    backgroundColor: '#ecf0f4',
    cursor: 'pointer',
    boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
  },
});

const SmallDownloadAvatar = styled(Avatar)(({ theme }) => ({
  width: 30,
  height: 30,
  border: `2px solid ${theme.palette.background.paper}`,
  backgroundColor: '#F07B0E',
}));

const SmallDeleteAvatar = styled(Avatar)(({ theme }) => ({
  width: 30,
  height: 30,
  border: `2px solid ${theme.palette.background.paper}`,
  backgroundColor: '#d32f2f',
}));

const SmallEditAvatar = styled(Avatar)(({ theme }) => ({
  width: 30,
  height: 30,
  border: `2px solid ${theme.palette.background.paper}`,
  backgroundColor: '#F07B0E',
}));

const ClientDetails = ({
  leadDetails,
  handleToggleNotifyUserDialog,
  editLeadDetails,
  handleEditLeadDetails,
  selectedLead,
  workflowStatusByPipeLine,
  priorities,
}) => {
  console.log('🚀 ~ ClientDetails ~ leadDetails:', leadDetails);
  const theme = createTheme();
  const clientInfoRef = useRef(null);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const CustomButton = styled(Button)({
    backgroundColor: '#F07B0E',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#f1785a',
    },
    width: 'fit-content',
    alignSelf: isSmallScreen ? 'center' : 'end',
  });

  return (
    <>
      {' '}
      {/* Client Details: Lead Owner Section */}
      {/* <CustomPaper>
      <Grid container direction={'row'} rowGap={2} justifyContent={'space-between'}>
        <Grid item xs={12} sm={6} md={6} lg={6}>
          <Stack direction={'row'} spacing={4}>
            <Stack direction={'column'} spacing={2} sx={{color: '#626A72', fontWeight: '500'}}>
              <Typography sx={{ fontSize: '12px', fontWeight: '700', alignSelf: 'end' }} component="p">Lead Owner</Typography>
              <Typography sx={{ fontSize: '12px', fontWeight: '700', alignSelf: 'end' }} component="p">Probablity</Typography>
              <Typography sx={{ fontSize: '12px', fontWeight: '700', alignSelf: 'end' }} component="p">Total Budget</Typography>
              <Typography sx={{ fontSize: '12px', fontWeight: '700', alignSelf: 'end' }} component="p">Priority</Typography>
            </Stack>
            <Stack direction={'column'} spacing={2}>
              <Typography sx={{ fontSize: '12px', fontWeight: '700', alignSelf: 'start' }} component="p">{leadDetails?.leadOwner}</Typography>
              <Typography sx={{ fontSize: '12px', fontWeight: '700', alignSelf: 'start' }} component="p">{leadDetails?.probability ?? '_'}</Typography>
              <Typography sx={{ fontSize: '12px', fontWeight: '700', alignSelf: 'start' }} component="p">{leadDetails?.amount ?? '_'}</Typography>
              <Typography sx={{ fontSize: '12px', fontWeight: '700', alignSelf: 'start' }} component="p">{leadDetails?.leadPriority ?? '_'}</Typography>
            </Stack>
          </Stack>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6}>
          <Stack>
            
           { AuthStore.userDetails.Role.toUpperCase() === 'SUAD'
&& <CustomButton variant="contained" size="small" onClick={() => handleToggleNotifyUserDialog(true)}>Assign Lead</CustomButton>
          }
          </Stack>
        </Grid>
      </Grid>
    </CustomPaper> */}
      {/* Client Details: Contacted Person Section */}
      <Stack>
        {/* <Paper>
        <Stack direction={'column'}>
          <Stack direction={'row'} sx={{ borderBottom: '1px solid #c7c7c7', px: '30px', py: '20px', backgroundColor: '#cce6e6' }}>
            <Typography sx={{ fontWeight: '600', alignSelf: 'start',  }} component="p">Contacted Person</Typography>
          </Stack>
          <Stack direction={'row'} spacing={2} sx={{ px: '30px', py: '20px' }}>
            <Stack><Avatar sx={{ width: 30, height: 30 }} alt="Remy Sharp"/></Stack>
            <Stack>
              <Typography sx={{ fontSize: '12px', alignSelf: 'start' }} component="p">{leadDetails.leadOwner}</Typography>
              <Stack direction={'row'} alignItems={'center'} sx={{mt: '3px'}}>
                <DraftsOutlined color="warning" sx={{fontSize: '13px', marginRight:'3px'}}></DraftsOutlined>
                <Typography sx={{ fontSize: '12px', alignSelf: 'start' }} component="p">{leadDetails.emailId}</Typography>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Paper> */}
        {/* <Grid item xs={12} sm={6} md={6} lg={6} sx={{borderLeft: isSmallScreen ? 'none' : '1px solid #e2e2e2;'}}>
            <Stack direction={'column'} spacing={2}>
              <Typography sx={{ fontWeight: '600', alignSelf: 'start'}} component="p">Next Action</Typography>
              <Stack direction={'row'} spacing={10} px={'12px'}>
                <div id="next-action-date-container">
                  <span>Jan 2</span>
                </div>
                <Typography sx={{ fontSize: '12px', alignSelf: 'start', pt: '4px' }} component="p">Call meeting with client</Typography>
              </Stack>
            </Stack>
          </Grid> */}
      </Stack>
      {/* Client Details: Client Info Section */}
      <Stack>
        <Paper sx={{ boxShadow: 3, borderRadius: 1 }}>
          <Stack
            direction={'row'}
            sx={{
              borderBottom: '1px solid #c7c7c7',
              px: '30px',
              py: '20px',
              backgroundColor: '#cce6e6',
            }}
          >
            <Typography sx={{ fontWeight: '600', alignSelf: 'start' }} component="p">
              Client Details
            </Typography>
            {editLeadDetails ? (
              ''
            ) : (
              <CustomButton sx={{ ml: 'auto' }} variant="contained" size="small" onClick={handleEditLeadDetails}>
                Edit
              </CustomButton>
            )}
          </Stack>
          <BorderLinearProgress
            color="primary"
            variant="determinate"
            value={calculateCompletionPercentage(leadDetails, [
              'customerName',
              'emailId',
              'requirement',
              'leadSource',
              'contactNo',
              'amount',
              'masterLife',
              'leadSiteDimension',
              'projectValue',
              'builtUpArea',
              'closeDate',
              'workFlowStatusName',
              'workFlowSubStatusName',
              'leadPriority',
              'probability',
              'clientPointOfContact',
              'siteAddress',
              'constructionStartTimeLine',
              'projectTimeLine',
              'contractName',
              'leadHandledBy',
              'description',
              'tags',
            ])}
          />
          {editLeadDetails ? (
            <EditLeadDetails
              leadDetails={leadDetails}
              pipeLineId={selectedLead.pipeLinesId}
              workflowStatusByPipeLine={workflowStatusByPipeLine}
              priorities={priorities}
              handleEditLeadDetails={handleEditLeadDetails}
            ></EditLeadDetails>
          ) : (
            <ReadOnlyLeadDetails leadDetails={leadDetails}></ReadOnlyLeadDetails>
          )}
        </Paper>
      </Stack>
    </>
  );
};

export default ClientDetails;
